module.exports = __webpack_public_path__ + "img/小人.b34af9d1.svg";